export const forwardParams = (url: string, params: string[]) => {
  const formattedParams = params.reduce(
    (acc: { [key: string]: string }, param: string) => {
      acc[`deep_link_sub${Object.keys(acc).length + 1}`] = param;
      return acc;
    },
    {}
  );

  return `${url}?${new URLSearchParams(formattedParams).toString()}`;
};
